<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input User Staff</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper mb-3">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Full Name">
                                <b-form-input v-model="input.fullname" name="fullName" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="User Name">
                                <b-form-input v-model="input.username" name="userName" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Level - Role">
                                <multiselect name="levelRole"
                                    :value="optionRole.find(item => item.id == input.role) || null"
                                    :options="optionRole" :internal-search="true" :allow-empty="false"
                                    deselect-label="" select-label="" label="name" track-by="id"
                                    placeholder="Pilih Level - Role"
                                    @input="input.role = $event ? $event.id : null" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Cabang">
                                <div class="d-flex">
                                    <multiselect
                                        name="cabang"
                                        v-model="input.cabang" 
                                        :options="optionCabang" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Pilih Cabang --"
                                    />
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Email">
                                <b-form-input v-model="input.email" name="email" type="email"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="No. Hp">
                                <b-form-input v-model="input.noHp" name="noHp"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Status">
                                <b-form-select v-model="input.isActive" name="status" :options="optionStatus" required>
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                
                <b-alert show variant="warning">
                    * Password default adalah 123456. 
                    User akan diminta untuk mengganti password saat pertama kali login.
                </b-alert>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="userStaffSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input User Staff" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput user staff ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-user-staff',
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input: {
                fullname: "",
                username: "",
                role: null,
                cabang: { id: null, name: null },
                email: "",
                noHp: "",
                isActive: null
            },
            optionRole: [],
            optionCabang: [],
            optionStatus: [
                { value: true, text: 'Aktif'},
                { value: false, text: 'Tidak Aktif'},
            ],
            isLoading: false
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getRole = this.$axios.get("role/").then(response => {
                this.optionRole = response.data

                for (var x of this.optionRole) {
                    x.name = "Level "+x.level+" - "+x.name
                }
            })

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.optionCabang.push(element)
                })
            })

            Promise.all([getRole, getCabang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data User Staff -----------------

            payload.append('username', this.input.username)
            payload.append('fullname', this.input.fullname)

            if (this.$helper.isNotNullAndNotEmpty(this.input.email)) payload.append('email', this.input.email)
            if (this.$helper.isNotNullAndNotEmpty(this.input.noHp))  payload.append('noHp', this.input.noHp)
            
            payload.append('roleId', this.input.role)
            payload.append('cabangId', this.input.cabang.id)
            payload.append('isActive', this.input.isActive)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post('user/', payload).then(response => {
                this.$helper.setFlash(`User Staff baru telah berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.cabang.id == null) {
                this.$helper.toastErr(this, "Mohon masukkan 1 kota cabang")
            } 
            else this.$bvModal.show("modal-confirm-input")
        }

    },

    created(){
        this.init()
    }
}
</script>
